import { MAX_COMBAT_EVENTS } from "odyssey-shared";
import { HitFeed } from "./hit-feed.ts";

/**
 * The page's one hit feed (P2.1-T4): the session pushes the hits its combat frames name, and the damage numbers
 * surface (`world-ui/damage-numbers/`) drains them each frame, so neither names the other and `scene.ts` names
 * neither. It holds two ticks of a page's most events.
 */
export const PAGE_HITS = new HitFeed(2 * MAX_COMBAT_EVENTS);
